import { ActionTree, MutationTree } from 'vuex'
import { User, LoginInfo, RootState } from '@/types'
import { app } from '@/firebase'
import { camelCase } from 'lodash'

export interface State {
    /** user can be undefined, if no one is logged in */
    user: User | undefined
    error?: string
}

export const namespaced = true

export const state: State = {
    user: undefined,
    error: undefined,
}

export const mutations: MutationTree<State> = {
    ADDUSER(state, user) {
        state.user = {
            ...user,
            ...(user.updatedAt ? { updatedAt: new Date(user.updatedAt) } : {}),
        }
    },
    DELETEUSER() {
        state.user = undefined
    },
    ADD_LOGIN_ERROR(state, error) {
        state.error = error
    },
    CLEAR_LOGIN_ERROR() {
        state.error = undefined
    },
}

export const actions: ActionTree<State, RootState> = {
    addUser({ commit }, user: User) {
        commit('ADDUSER', user)
        commit('CLEAR_LOGIN_ERROR')
    },
    deleteUser({ commit }) {
        commit('DELETEUSER')
    },
    login({ commit }, loginInfo: LoginInfo) {
        return app
            .auth()
            .signInWithEmailAndPassword(loginInfo.email, loginInfo.password)
            .then(({ user }) => {
                return !user && Promise.reject({ code: 'userNotFound' })
            })
            .catch((error) => {
                commit('ADD_LOGIN_ERROR', camelCase(error.code.split('/')[1]))
            })
    },
    logout() {
        app.auth().signOut()
    },
}
